const { useState } = React;

function AgentPage() {
    const [activeTab, setActiveTab] = useState('listings');

    return (
        <div className="w-full bg-white">
            {/* Navigation */}
            <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-lg border-b border-blue-100/20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center h-16">
                        <a href="#home" className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-transparent">
                            Rent Deck
                        </a>
                        <div className="flex gap-4">
                            <a href="#home" className="px-4 py-2 text-gray-700 hover:text-blue-600 transition-colors font-medium">
                                Home
                            </a>
                            <a href="#client" className="px-4 py-2 text-gray-700 hover:text-blue-600 transition-colors font-medium">
                                Switch to Client
                            </a>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Hero Section */}
            <section className="relative pt-32 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-blue-50 to-white">
                <div className="max-w-6xl mx-auto">
                    <div className="flex justify-between items-start gap-8">
                        <div>
                            <h1 className="text-5xl sm:text-6xl font-bold text-gray-900 mb-6">
                                Manage Your Listings
                            </h1>
                            <p className="text-xl text-gray-600 max-w-2xl mb-8">
                                Upload properties, manage appointments, and grow your business with Rent Deck's agent dashboard.
                            </p>
                            <button className="px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-lg hover:shadow-lg hover:shadow-blue-500/50 transition-all font-semibold">
                                + Add New Listing
                            </button>
                        </div>
                        <div className="hidden lg:block w-40 h-40 rounded-2xl bg-gradient-to-br from-blue-100 to-blue-50 flex items-center justify-center text-7xl">
                            👨‍💼
                        </div>
                    </div>
                </div>
            </section>

            {/* Stats Section */}
            <section className="py-12 px-4 sm:px-6 lg:px-8 bg-white border-b border-blue-100">
                <div className="max-w-6xl mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                        {[
                            { label: 'Active Listings', value: '12', icon: '📋' },
                            { label: 'Total Views', value: '2,450', icon: '👀' },
                            { label: 'Bookings', value: '23', icon: '📅' },
                            { label: 'Conversion Rate', value: '18.5%', icon: '📈' }
                        ].map((stat, index) => (
                            <div key={index} className="p-6 rounded-2xl bg-gradient-to-br from-white to-blue-50 border border-blue-100 hover:border-blue-300 transition-all">
                                <div className="text-4xl mb-3">{stat.icon}</div>
                                <div className="text-3xl font-bold text-gray-900 mb-1">{stat.value}</div>
                                <div className="text-gray-600 text-sm">{stat.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Tabs */}
            <section className="py-12 px-4 sm:px-6 lg:px-8 bg-white border-b border-blue-100">
                <div className="max-w-6xl mx-auto">
                    <div className="flex gap-4 border-b border-gray-200 mb-8 overflow-x-auto">
                        {['listings', 'appointments', 'analytics', 'clients'].map((tab) => (
                            <button
                                key={tab}
                                onClick={() => setActiveTab(tab)}
                                className={`pb-4 px-4 font-semibold transition-all whitespace-nowrap ${activeTab === tab ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-600 hover:text-gray-900'}`}
                            >
                                {tab.charAt(0).toUpperCase() + tab.slice(1)}
                            </button>
                        ))}
                    </div>

                    {/* Content */}
                    {activeTab === 'listings' && (
                        <div className="space-y-6">
                            {[1, 2, 3].map((listing) => (
                                <div key={listing} className="p-6 rounded-2xl border border-blue-100 hover:border-blue-300 hover:shadow-lg transition-all hover:shadow-blue-500/10 flex gap-6 items-center">
                                    <div className="w-32 h-32 rounded-xl bg-gradient-to-br from-blue-100 to-blue-50 flex items-center justify-center text-5xl flex-shrink-0">
                                        🏠
                                    </div>
                                    <div className="flex-grow">
                                        <h3 className="text-xl font-bold text-gray-900 mb-2">Modern 3-Bedroom Apartment in Lekki</h3>
                                        <p className="text-gray-600 mb-4">₦4,500,000 • Lekki, Lagos</p>
                                        <div className="flex gap-6 text-sm text-gray-600 mb-4">
                                            <span>Views: 245</span>
                                            <span>Bookings: 12</span>
                                            <span>Status: <span className="text-green-600 font-semibold">Published</span></span>
                                        </div>
                                    </div>
                                    <div className="flex gap-2 flex-col">
                                        <button className="px-4 py-2 bg-blue-100 text-blue-600 rounded-lg hover:bg-blue-200 transition-all font-medium text-sm">
                                            Edit
                                        </button>
                                        <button className="px-4 py-2 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 transition-all font-medium text-sm">
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {activeTab === 'appointments' && (
                        <div className="space-y-4">
                            {[1, 2, 3, 4].map((appointment) => (
                                <div key={appointment} className="p-4 rounded-2xl border border-blue-100 flex justify-between items-center">
                                    <div>
                                        <h4 className="font-semibold text-gray-900">Viewing Appointment</h4>
                                        <p className="text-sm text-gray-600">March {20 + appointment}, 2:00 PM • Property #{appointment}</p>
                                    </div>
                                    <div className="flex gap-2">
                                        <button className="px-4 py-2 bg-green-100 text-green-600 rounded-lg hover:bg-green-200 transition-all font-medium text-sm">
                                            Confirm
                                        </button>
                                        <button className="px-4 py-2 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 transition-all font-medium text-sm">
                                            Decline
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {activeTab === 'analytics' && (
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                            <div className="p-8 rounded-2xl border border-blue-100 bg-gradient-to-br from-white to-blue-50">
                                <h4 className="text-lg font-semibold text-gray-900 mb-6">Performance Chart</h4>
                                <div className="h-40 flex items-end justify-around gap-2">
                                    {[45, 60, 50, 75, 80, 65, 70].map((height, i) => (
                                        <div key={i} className="flex-1 bg-gradient-to-t from-blue-600 to-blue-400 rounded-t-lg" style={{ height: `${height}%` }}></div>
                                    ))}
                                </div>
                            </div>
                            <div className="p-8 rounded-2xl border border-blue-100 bg-gradient-to-br from-white to-blue-50">
                                <h4 className="text-lg font-semibold text-gray-900 mb-6">Top Performing Properties</h4>
                                <ul className="space-y-3">
                                    {['Modern Apartment', 'Luxury Duplex', 'Contemporary House'].map((prop, i) => (
                                        <li key={i} className="flex justify-between">
                                            <span className="text-gray-700">{prop}</span>
                                            <span className="font-semibold text-blue-600">{450 + i * 100} views</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    )}

                    {activeTab === 'clients' && (
                        <div className="space-y-4">
                            {[1, 2, 3, 4, 5].map((client) => (
                                <div key={client} className="p-4 rounded-2xl border border-blue-100 flex justify-between items-center">
                                    <div className="flex items-center gap-4">
                                        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-600 to-blue-400 flex items-center justify-center text-white font-semibold">
                                            {client}
                                        </div>
                                        <div>
                                            <h4 className="font-semibold text-gray-900">Client Name #{client}</h4>
                                            <p className="text-sm text-gray-600">john{client}@email.com</p>
                                        </div>
                                    </div>
                                    <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all font-medium text-sm">
                                        Message
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>

            {/* Footer */}
            <Footer />
        </div>
    );
}

export default AgentPage;
